import { Box, Tooltip } from "@mui/material";
import { t } from "i18next";
import "./ticket-arrow.scss";

function TicketArrow({ list = [], icon }) {
    return (
        <Box className="ticket-arrow" sx={{ flex: 0.75, borderColor: "grey.400" , width:'100%'}}>
            {icon}

            {list?.slice(0, list.length - 1).map((segment, index) => {
                return (
                    <Tooltip
                        key={index}
                        title={`${
                            parseInt(segment?.connection_time?.split(":")[0]) === 0
                                ? `${t("Flight.Non-Stop")}`
                                : segment?.connection_time + `${t("Flight.Stop")}`
                        } `}
                    >
                        <span className="ticket-arrow__point">
                            <span className="ticket-arrow__iata">{segment?.destination?.terminal?.code}</span>
                        </span>
                    </Tooltip>
                );
            })}
            <div className="ticket-arrow__point"></div>
        </Box>
    );
}

export default TicketArrow;
